module.exports = __webpack_public_path__ + "stylesheets/background_7a71fd5a5936ecc84f89583f9ef1b4b7.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/background.less
// module id = kfHS
// module chunks = 118